import { FC, HTMLProps } from 'react';

export const RuIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M22.6027 17.625C23.4946 15.9472 24 14.0326 24 12C24 9.96736 23.4946 8.05277 22.6027 6.375H1.39733C0.505375 8.05277 0 9.96736 0 12C0 14.0326 0.505375 15.9472 1.39733 17.625H22.6027Z"
        fill="#0052B4"
      />
      <path
        d="M23.2724 16.125C21.5903 20.7204 17.1783 24 12.0002 24C6.82219 24 2.41015 20.7204 0.728027 16.125H23.2724Z"
        fill="#D80027"
      />
      <path
        d="M23.2724 7.875H0.728027C2.41015 3.27964 6.82219 0 12.0002 0C17.1783 0 21.5903 3.27964 23.2724 7.875Z"
        fill="#EEEEEE"
      />
    </svg>
  );
};
